$(document).ready(function(){

  
  if ($(window).width() >= 1024) {
    $('.blocks').hover(
      function(){ $(this).addClass('active') }

    )
  }else{
    $(".blocks").on("click", function () {
      $(this).addClass('active') 
    });
  }
  $('.app_slider').slick({
    dots: true,
    arrows: true
  });

  $('.blu_app_slider').slick({ 
    dots: true,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000
  });




  
  $(".popup_btn").on("click", function () {
    var modal = $(this).data("modal");
    $(modal).show();
    $('body').toggleClass('model_open');
  });
  $('.popup_close ').click(function () {
    $('.modal').hide();
    $('body').removeClass('model_open');
  });
  $(".modal").on("click", function (e) {
    var className = e.target.className;
    if (className === "modal") {
      $(this).closest(".modal").hide();
      $('body').removeClass('model_open');
    }
  });


  $('.add_to_cart').on('click',function () {
    debugger;
    $('.notification__message').addClass('active');
    $(this).children().text('added');
    setTimeout(function(){ 
      $('.notification__message').removeClass('active');
      $('.add_to_cart span').text('Add to Cart');
    }, 3000);
  });   



     


});

 $(document).on("click",".dlu_dental_data #what_you_get",function(){ 
     var nav = $('.what_you_get_cust');
 if (nav.length) {
  var position = nav.offset().top ;
   $("body, html").animate({ scrollTop: position}, 2000, 'linear')
 }
 	});


$(document).on("click",".dlu_dental_data #how_it_works",function(){ 
     var nav = $('.blu-dental_featured');
 if (nav.length) {
  var position = nav.offset().top;
   $("body, html").animate({ scrollTop: position}, 2000, 'linear')
 }
 	});


$(document).on("click",".dlu_dental_data #faq_s",function(){ 
     var nav = $('.faq_section');
 if (nav.length) {
  var position = nav.offset().top;
   $("body, html").animate({ scrollTop: position}, 2000, 'linear')
 }
 	});


$(document).on("click",".dlu_dental_data #get_started",function(){ 
     var nav = $('.blu_toothbrush_cust');
 if (nav.length) {
  var position = nav.offset().top;
   $("body, html").animate({ scrollTop: position}, 2000, 'linear')
 }
 	});